import {
  type RequestMagicLinkForLoginRequest,
  type RequestMagicLinkForSignupRequest,
} from './aliases';
import {
  type MagicLinkSignupEmailVerifyRequest,
  type MagicLinkSignupEmailVerifyResponse,
} from './types';

import {
  MAGIC_LINK_REGISTER_ENDPOINT,
  MAGIC_LINK_REQUEST_ENDPOINT,
  MAGIC_LINK_REQUEST_SYNC_ENDPOINT,
  SIGNUP_TOKEN_VALIDATION_ENDPOINT,
} from '@/constants/endpoints';
import { Platform } from '@/modules/activityTracker/constants';
import http, { typedHttp } from '@/modules/http';
import { type AxiosCompatibleResponse } from '@/modules/http/types.ts';
import { isEmail } from '@/utils/isEmail.ts';

export function requestMagicLink(params: RequestMagicLinkForLoginRequest) {
  return typedHttp.post(MAGIC_LINK_REQUEST_ENDPOINT, params);
}

export function registerMagicLink(params: RequestMagicLinkForSignupRequest) {
  return typedHttp.post(MAGIC_LINK_REGISTER_ENDPOINT, params);
}

export function requestMagicLinkSync(identifier: string) {
  const payload = isEmail(identifier)
    ? { email: identifier }
    : { username: identifier };

  return typedHttp.post(MAGIC_LINK_REQUEST_SYNC_ENDPOINT, {
    ...payload,
    requesting_platform: Platform.Web,
  });
}

export function verifyEmailMagicLinkSignup(
  params: MagicLinkSignupEmailVerifyRequest
): Promise<AxiosCompatibleResponse<MagicLinkSignupEmailVerifyResponse>> {
  return http.put(SIGNUP_TOKEN_VALIDATION_ENDPOINT, params);
}
